export default __webpack_public_path__ + "static/media/parameters-test.06524d01.svg";